import cn from 'classnames';
import LazyImage from "../../LazyImage";
import { jsx as _jsx } from "react/jsx-runtime";
var Image = function Image(_ref) {
  var className = _ref.className,
    name = _ref.name,
    url = _ref.url,
    isDark = _ref.isDark,
    onOpenImagePreview = _ref.onOpenImagePreview;
  return /*#__PURE__*/_jsx("div", {
    className: cn('inline-flex flex-shrink-0', className),
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: cn('w-120 h-120 rounded-5 cursor-zoom-in overflow-hidden focus:outline-none', isDark ? 'bg-base-lighter-56' : 'bg-gray-main'),
      onClick: function onClick() {
        onOpenImagePreview({
          url: url,
          name: name
        });
      },
      children: /*#__PURE__*/_jsx(LazyImage, {
        className: "w-full h-full",
        imgClassName: "object-cover",
        alt: name,
        src: url,
        imgxParams: {
          w: 120,
          h: 120,
          dpr: 2,
          crop: 'faces'
        },
        dark: isDark
      })
    })
  });
};
export default Image;